import axios from "axios";

// Backend URL Configuration
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Use local API if in development
export const getApiUrl = () => {
  return API;
};

export const apiCall = (endpoint, config = {}) => {
  const apiUrl = getApiUrl();
  const cleanEndpoint = endpoint.startsWith("/") ? endpoint.substring(1) : endpoint;
  return axios({
    url: `${apiUrl}/${cleanEndpoint}`,
    ...config,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      ...config.headers
    }
  });
};

/**
 * Returns a secure proxy URL for loading files/images.
 * If the path is already an absolute URL or a data URI, it is returned unchanged.
 */
export const getFileUrl = (path) => {
  if (!path) return "";
  if (path.startsWith("data:") || path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }
  const cleanPath = path.startsWith("/") ? path.substring(1) : path;
  return `${API}/files/${cleanPath}`;
};
